import React from 'react';
import PropTypes from 'prop-types';

import {Commands as ModuleCommands} from 'views/module';

import {simplifyQuestions} from 'utils/user_bio';

const SlashCommands = (props) => {
  const {caregiverBackend, caregiverBioQuestions, caregiverRn} = props;

  const caregiverBio = React.useMemo(() => {
    if (!caregiverBioQuestions?.questions) {
      return {};
    }

    return simplifyQuestions(caregiverBioQuestions.questions);
  }, [caregiverBioQuestions]);

  const slashCommandProps = React.useMemo(() => {
    const email = caregiverBio.email;

    return {
      communicationTarget: {
        email,
        sendEmail: async (emailData, onSuccess, onError=()=>undefined) => {
          return caregiverBackend.messages.sendEmail(caregiverRn, emailData, onSuccess, onError);
        },
      },
      resources: [
        {type: 'CAREGIVER', rn: caregiverRn},
      ],
      playbook: {
        execute: async (playbookRn, primaryResourceRn) => {
          await caregiverBackend.playbooks.execute(playbookRn, primaryResourceRn);
        },
      },
    };
  }, [caregiverBackend, caregiverBio, caregiverRn]);

  return (
    <ModuleCommands
      {...slashCommandProps}
    />
  );
};

SlashCommands.propTypes = {
  caregiverBackend: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverRn: PropTypes.string.isRequired,
};

export default React.memo(SlashCommands);
